import { UPDATE_CART } from './actionTypes';

// eslint-disable-next-line import/prefer-default-export
export const setShopState = (cart) => (dispatch) => {
  dispatch({
    type: UPDATE_CART,
    payload: {
      loading: false,
      data: cart,
    },
  });
};
